import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import stateCityData from '../town_city.json';
import './ConsignmentForm.css'; // You can customize CSS styles in this file.

const CreateShipment = () => {
  const [billingType, setBillingType] = useState('Bill to Company');
  const [consignmentNumber, setConsignmentNumber] = useState('');
  const [dateOfConsignment, setDateOfConsignment] = useState(new Date());
  const [forwardedThrough, setForwardedThrough] = useState('Air');
  const [refNumber, setRefNumber] = useState('');
  const [sender, setSender] = useState({ name: '', address: '', city: '', pincode: '', phone: '', email: '', gst: '' });
  const [receiver, setReceiver] = useState({ name: '', address: '', city: '', pincode: '', phone: '', email: '' });
  const [courierDetails, setCourierDetails] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchConsignmentNumber = async () => {
      try {
        const response = await axios.get('https://kartikenterprisesindia.co.in/api/consignments/nextid');
        setConsignmentNumber(response.data.consignmentNumber);
      } catch (error) {
        alert('Failed to fetch consignment number');
      }
    };
    fetchConsignmentNumber();
  }, []);

  const handleStateChange = (isSender, state) => {
    if (isSender) {
      setSender({ ...sender, state, city: '' }); // Reset city when state changes
    } else {
      setReceiver({ ...receiver, state, city: '' });
    }
  };

  const handleCityChange = (isSender, city) => {
    if (isSender) {
      setSender({ ...sender, city });
    } else {
      setReceiver({ ...receiver, city });
    }
  };

  const addCourierDetail = () => {
    setCourierDetails([
      ...courierDetails,
      {
        type: '',
        product: 'Full Truck Load',
        kg: '',
        pcs: '',
        length: '',
        width: '',
        height: '',
        volumetric: '',
        freight: '',
        docCharge: '',
        otherCharge: '',
        gst: 0,
        total: 0,
        paymentMethod: 'Cash',
        codAmount: '',
      },
    ]);
  };

  const handleCourierChange = (index, field, value) => {
    const updatedCouriers = [...courierDetails];
    updatedCouriers[index][field] = value;

    if (['length', 'width', 'height'].includes(field)) {
      const { length, width, height } = updatedCouriers[index];
      updatedCouriers[index].volumetric = ((length * width * height) / 5000).toFixed(2) || '';
    }

    if (['freight', 'docCharge', 'otherCharge'].includes(field)) {
      const charges =
        parseFloat(updatedCouriers[index].freight || 0) +
        parseFloat(updatedCouriers[index].docCharge || 0) +
        parseFloat(updatedCouriers[index].otherCharge || 0);
      updatedCouriers[index].gst = (charges * 0.18).toFixed(2);
      updatedCouriers[index].total = (charges + parseFloat(updatedCouriers[index].gst)).toFixed(2);
    }

    setCourierDetails(updatedCouriers);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = document.cookie.split('; ').find(row => row.startsWith('auth_token='));
    const userId = token ? JSON.parse(atob(token.split('=')[1].split('.')[1])).userId : null;

    const formData = {
      userId,
      billingType,
      consignmentNumber,
      dateOfConsignment,
      forwardedThrough,
      refNumber,
      sender,
      receiver,
      courierDetails,
    };

    try {
      await axios.post('https://kartikenterprisesindia.co.in/api/consignments/', formData);
      alert('Consignment created successfully!');
    } catch (error) {
      console.error('Error:', error.response?.data || error.message);
      alert(`Error creating consignment: ${error.response?.data?.message || error.message}`);
    }
  };

  return (
    <form className="consignment-form" onSubmit={handleSubmit}>
      <h2>Consignment hj</h2>
      <div className="row">
        <div className="column50">
          <label>Billing Type</label>
          <select className="option-style" value={billingType} onChange={(e) => setBillingType(e.target.value)}>
            <option value="Bill to Company">Bill to Company</option>
            <option value="Sub Contracting">Sub Contracting</option>
            <option value="Retail">Retail</option>
          </select>
        </div>
        <div className="column50">
          <label>Consignment Number</label>
          <input type="text" value={consignmentNumber} readOnly />
        </div>
      </div>
      <div className="row">
        <div className="column30">
          <label>Date of Consignment</label>
          <input className="input"
            type="date"
            value={dateOfConsignment.toISOString().split('T')[0]}
            onChange={(e) => setDateOfConsignment(new Date(e.target.value))}
          />
        </div>
        <div className="column30">
          <label>Forwarded Through</label>
          <select className="option-style" value={forwardedThrough} onChange={(e) => setForwardedThrough(e.target.value)}>
            <option value="Air">Air</option>
            <option value="Road">Road</option>
            <option value="Sea">Sea</option>
          </select>
        </div>
        <div className="column30">
          <label>Ref Number</label>
          <input type="text" value={refNumber} onChange={(e) => setRefNumber(e.target.value)} />
        </div>
      </div>
      






      <h3>Sender Information</h3>
      <div className="row">
        <div className="column30">
          <label>Sender Name</label>
          <input placeholder="Sender Name" value={sender.name} onChange={(e) => setSender({ ...sender, name: e.target.value })} />
        </div>
        <div className="column30">
          <label>Sender Phone</label>
          <input placeholder="Sender Phone" value={sender.phone} onChange={(e) => setSender({ ...sender, phone: e.target.value })} />
        </div>
        <div className="column30">
          <label>Sender Email</label>
          <input placeholder="Sender Email" value={sender.email} onChange={(e) => setSender({ ...sender, email: e.target.value })} />
        </div>
      </div>
      <div className="row">
      <div className="column30">
          <label>Sender State</label>
          <select
            value={sender.state}
            onChange={(e) => handleStateChange(true, e.target.value)}
          >
            <option value="">Select State</option>
            {Object.keys(stateCityData).map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </select>
        </div>
        <div className="column30">
          <label>Sender City</label>
          <select
            value={sender.city}
            onChange={(e) => handleCityChange(true, e.target.value)}
            disabled={!sender.state}
          >
            <option value="">Select City</option>
            {stateCityData[sender.state]?.map((city) => (
              <option key={city} value={city}>
                {city}
              </option>
            ))}
          </select>
        </div>
        <div className="column30">
        <label>Sender Pincode</label>
        <input placeholder="Sender Pincode" value={sender.pincode} onChange={(e) => setSender({ ...sender, pincode: e.target.value })} />
        </div>
      </div>
      <div className="row">
        <div className="column100">
        <label>Sender Address</label>
        <input placeholder="Sender Address" value={sender.address} onChange={(e) => setSender({ ...sender, address: e.target.value })} />
        </div>
      </div>
      <div className="row">
        <div className="column100">
        <label>Sender GST Number</label>
        <input placeholder="GST Number" value={sender.gst} onChange={(e) => setSender({ ...sender, gst: e.target.value })} />
        </div>
      </div>

      <h3>receiver Information</h3>
      <div className="row">
        <div className="column30">
          <label>receiver Name</label>
          <input placeholder="receiver Name" value={receiver.name} onChange={(e) => setReceiver({ ...receiver, name: e.target.value })} />
        </div>
        <div className="column30">
          <label>receiver Phone</label>
          <input placeholder="receiver Phone" value={receiver.phone} onChange={(e) => setReceiver({ ...receiver, phone: e.target.value })} />
        </div>
        <div className="column30">
          <label>receiver Email</label>
          <input placeholder="receiver Email" value={receiver.email} onChange={(e) => setReceiver({ ...receiver, email: e.target.value })} />
        </div>
      </div>
      <div className="row">
      <div className="column30">
        <label>Receiver State</label>
        <select
          value={receiver.state}
          onChange={(e) => handleStateChange(false, e.target.value)} // Corrected to false
        >
          <option value="">Select State</option>
          {Object.keys(stateCityData).map((state) => (
            <option key={state} value={state}>
              {state}
            </option>
          ))}
        </select>
      </div>
      <div className="column30">
        <label>Receiver City</label>
        <select
          value={receiver.city}
          onChange={(e) => handleCityChange(false, e.target.value)} // Corrected to false
          disabled={!receiver.state}
        >
          <option value="">Select City</option>
          {stateCityData[receiver.state]?.map((city) => (
            <option key={city} value={city}>
              {city}
            </option>
          ))}
        </select>
      </div>

        <div className="column30">
        <label>receiver Pincode</label>
        <input placeholder="receiver Pincode" value={receiver.pincode} onChange={(e) => setReceiver({ ...receiver, pincode: e.target.value })} />
        </div>
      </div>
      <div className="row">
        <div className="column100">
        <label>receiver Address</label>
        <input placeholder="receiver Address" value={receiver.address} onChange={(e) => setReceiver({ ...receiver, address: e.target.value })} />
        </div>
      </div>


      <h3>Courier Details</h3>
      {courierDetails.map((courier, index) => (
  <div key={index} className="courier-detail">
    <h4>Courier #{index + 1}</h4>
    <div className="row">
      <div className="column30">
        <label>Type</label>
        <input
          placeholder="Type"
          value={courier.type}
          onChange={(e) => handleCourierChange(index, 'type', e.target.value)}
        />
      </div>
      <div className="column30">
        <label>Product</label>
        <select
          value={courier.product}
          onChange={(e) => handleCourierChange(index, 'product', e.target.value)}
        >
          <option value="Full Truck Load">Full Truck Load</option>
          <option value="Partial Load">Partial Load</option>
        </select>
      </div>
      <div className="column30">
        <label>PCS </label>
        <input
          placeholder="Number of Pieces"
          type="number"
          value={courier.pcs}
          onChange={(e) => handleCourierChange(index, 'pcs', e.target.value)}
        />
      </div>
    </div>
    <div className="row">
      <div className="column30">
        <label>Length (cm)</label>
        <input
          placeholder="Length"
          type="number"
          value={courier.length}
          onChange={(e) => handleCourierChange(index, 'length', e.target.value)}
        />
      </div>
      <div className="column30">
        <label>Width (cm)</label>
        <input
          placeholder="Width"
          type="number"
          value={courier.width}
          onChange={(e) => handleCourierChange(index, 'width', e.target.value)}
        />
      </div>
      <div className="column30">
        <label>Height (cm)</label>
        <input
          placeholder="Height"
          type="number"
          value={courier.height}
          onChange={(e) => handleCourierChange(index, 'height', e.target.value)}
        />
      </div>
    </div>
    <div className="row">
      <div className="column30">
        <label>Volumetric Weight</label>
        <input
          readOnly
          value={courier.volumetric}
        />
      </div>
      <div className="column30">
        <label>Weight (kg)</label>
        <input
          placeholder="Weight"
          type="number"
          value={courier.kg}
          onChange={(e) => handleCourierChange(index, 'kg', e.target.value)}
        />
      </div>
      <div className="column30">
        <label>Freight (₹)</label>
        <input
          placeholder="Freight"
          type="number"
          value={courier.freight}
          onChange={(e) => handleCourierChange(index, 'freight', e.target.value)}
        />
      </div>
    </div>

    <div className="row">
      <div className="column30">
        <label>Doc Charges (₹)</label>
        <input
          placeholder="Document Charges"
          type="number"
          value={courier.docCharge}
          onChange={(e) => handleCourierChange(index, 'docCharge', e.target.value)}
        />
      </div>
      <div className="column30">
        <label>Other Charges (₹)</label>
        <input
          placeholder="Other Charges"
          type="number"
          value={courier.otherCharge}
          onChange={(e) => handleCourierChange(index, 'otherCharge', e.target.value)}
        />
      </div>
      <div className="column30">
        <label>GST (₹)</label>
        <input
          readOnly
          value={courier.gst}
        />
      </div>
      
    </div>
    <div className="row">
      <div className="column30">
        <label>Total (₹)</label>
        <input
          readOnly
          value={courier.total}
        />
      </div>
      <div className="column30">
        <label>Payment Method</label>
        <select
          value={courier.paymentMethod}
          onChange={(e) => handleCourierChange(index, 'paymentMethod', e.target.value)}
        >
          <option value="Cash">Cash</option>
          <option value="Credit">Credit</option>
        </select>
      </div>
      <div className="column30">
        <label>COD Amount (₹)</label>
        <input
          placeholder="COD Amount"
          type="number"
          value={courier.codAmount}
          onChange={(e) => handleCourierChange(index, 'codAmount', e.target.value)}
        />
      </div>
    </div>
    <hr />
  </div>
))}

      <button type="button" style={{backgroundColor:'green'}} onClick={addCourierDetail}>Add Courier Details</button>
      <button type="submit" style={{backgroundColor:'blue'}} >Submit</button>
    </form>
  );
};

export default CreateShipment;
